import React, { useEffect } from 'react';
import { useGoogleAds } from '@/hooks/useGoogleAds';
import { TrackingPixels } from '@/types/pixels';

type Props = {
  pixels: TrackingPixels['google_ads_pixels'];
};

const GoogleAdsPixels: React.FC<Props> = ({ pixels = [] }) => {
  const { onCheckoutVisit } = useGoogleAds();

  useEffect(() => {
    const addGoogleTag = (pixelId: string) => {
      const scriptTag = document.createElement('script');
      scriptTag.async = true;
      scriptTag.src = `https://www.googletagmanager.com/gtag/js?id=${pixelId}`;
      document.head.appendChild(scriptTag);

      const scriptConfig = document.createElement('script');
      scriptConfig.innerHTML = `
        window.dataLayer = window.dataLayer || [];
        function gtag() {
          dataLayer.push(arguments);
        }
        gtag('js', new Date());
        gtag('config', '${pixelId}');
      `;
      document.head.appendChild(scriptConfig);
    };

    pixels.forEach((pixel) => {
      addGoogleTag(pixel.pixelId);
      onCheckoutVisit();
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pixels]);

  return null;
};

export default GoogleAdsPixels;
